/*
 * Harriet Home — custom theme JavaScript
 *
 * Loaded from layout/theme.liquid. Pipeline ships this file as a stub of example
 * console.log listeners and leaves the <script> tag commented out; both are gone.
 *
 * Three independent features live here, as separate IIFEs:
 *
 *   1. Add-to-cart drawer  — intercepts theme:cart:popdown in the capture phase so
 *      Pipeline's popdown bar never renders, and opens the cart drawer once the
 *      updated cart has arrived.
 *   2. Header nav drawer   — the header renders ONE <nav data-nav-shared>; this moves
 *      it into the drawer below the mobile breakpoint and drives the slide panels.
 *   3. Description read more — the product description is rendered ONCE and collapsed
 *      with CSS; this only decides whether it overflows, and opens it on click.
 *
 * They do not interact: (1) works on [data-drawer="drawer-cart"] and document-level
 * theme:cart:* events, (2) works on [data-drawer="hamburger"] and pointer/key events
 * scoped to the header wrapper, (3) works on [data-read-more] inside product sections.
 * Keep them separate so any one can be reverted alone.
 *
 * Do not edit assets/theme.js, vendor.js or theme.css — see CONTRIBUTING.md.
 */


(function() {

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // Open the cart drawer after add to cart, instead of the popdown bar that
  // Pipeline shows at the top of the page.
  //
  // Pipeline's add to cart handler always dispatches `theme:cart:popdown`
  // unless the drawer already happens to be open (see assets/theme.js, the
  // `handleSuccess` method). `CartPopdown` listens for that event on
  // `document` during the bubble phase, so a capture phase listener here runs
  // first and can stop the event before the popdown ever renders.
  //
  // Both add to cart entry points (the main product form and the quick
  // add / upsell form) route through this one event, so intercepting it
  // covers both.
  document.addEventListener('theme:cart:popdown', function(event) {

    // On the cart page Pipeline refreshes the cart in place rather than
    // showing a popdown. Leave that behaviour alone.
    if (document.querySelector('[data-ajax-disable]')) {
      return;
    }

    // The drawer is only rendered when the cart type is Drawer or Popup, and
    // never on the cart template, so it may legitimately be absent.
    var cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!cartDrawer) {
      return;
    }

    event.stopPropagation();

    // Open the drawer only once the updated cart has arrived, so it is correct
    // the moment it appears.
    //
    // `handleSuccess` calls `updateHeaderTotal()` without awaiting it, so right
    // now the cart object the drawer holds is still the pre-add copy. Opening
    // immediately shows whatever was there before -- the empty state on a first
    // add -- for as long as the `/cart.js` request takes, measured at ~400ms.
    //
    // `theme:cart:change` is dispatched once that request resolves and the
    // fresh cart has been stored. Waiting for it also means no explicit reload
    // is needed: Pipeline's own `theme:drawer:open` handler re-renders from the
    // stored cart, which is up to date by then. Pipeline registered its
    // `theme:cart:change` listener at page load, ahead of this one, so its
    // handler runs first.
    //
    // The add button stays in its loading / success state throughout, so the
    // click is still visibly acknowledged during the wait.
    var opened = false;
    var fallbackTimer;

    function openCartDrawer() {
      if (opened) {
        return;
      }
      opened = true;
      clearTimeout(fallbackTimer);
      document.removeEventListener('theme:cart:change', openCartDrawer);
      cartDrawer.dispatchEvent(new CustomEvent('theme:drawer:open', {bubbles: true}));
    }

    document.addEventListener('theme:cart:change', openCartDrawer);

    // If the cart request fails, `theme:cart:change` never fires. Open anyway
    // rather than leaving the click unanswered. Contents may lag in that case,
    // which is still better than the drawer never appearing.
    fallbackTimer = setTimeout(openCartDrawer, 1500);
  }, true); // capture phase, so this runs before CartPopdown


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();


(function () {
  'use strict';

  var selectors = {
    wrapper: '[data-header-wrapper]',
    nav: '[data-nav-shared]',
    navHome: '[data-nav-home]',
    drawerTarget: '[data-nav-drawer-target]',
    drill: '[data-nav-open]',
    back: '[data-nav-close]',
    drawer: '[data-drawer="hamburger"]'
  };

  var classes = {
    showMobile: 'js__show__mobile',
    meganavVisible: 'meganav--visible',
    panelOpen: 'is-nav-open'
  };

  var wrapper = document.querySelector(selectors.wrapper);
  if (!wrapper) {
    return;
  }

  var nav = wrapper.querySelector(selectors.nav);
  var navHome = wrapper.querySelector(selectors.navHome);
  var drawerTarget = wrapper.querySelector(selectors.drawerTarget);
  var drawer = wrapper.querySelector(selectors.drawer);

  if (!nav || !navHome || !drawerTarget) {
    return;
  }

  // The two conditions theme.css also encodes as media queries. Kept in sync with
  // the mobile variable blocks in assets/custom.css.
  var narrow = window.matchMedia('(max-width: 479px)');
  var coarse = window.matchMedia('(pointer: coarse)');

  var openPanel = null;
  var mode = null;
  var ready = false;

  /* ----------------------------------------------------------------------
   * Mode
   * -------------------------------------------------------------------- */

  function isMobile() {
    return (
      wrapper.classList.contains(classes.showMobile) ||
      narrow.matches ||
      coarse.matches
    );
  }

  // Set only the attribute. Safe to call before theme.js has measured, because all
  // this drives is the row layout in custom.css.
  function applyModeAttr() {
    var next = isMobile() ? 'mobile' : 'desktop';
    if (next === mode) {
      return false;
    }
    mode = next;
    wrapper.setAttribute('data-header-mode', mode);
    return true;
  }

  // Deliberately separate, and never run before DOMContentLoaded. theme.js:4842
  // getMinWidth() deep-clones the wrapper and sums the [data-takes-space] column
  // widths to compute the swap threshold; if the nav had already been moved out of
  // its column, that measurement would come back near zero and the threshold would
  // be meaningless. No flash results from waiting: custom.css already hides the nav
  // column on mobile from the first paint, so only the move is outstanding.
  function applyRelocation() {
    if (mode === 'mobile') {
      if (!drawerTarget.contains(nav)) {
        // A move, not a copy: every listener bound to nav and its descendants
        // comes along, so nothing needs re-initialising.
        drawerTarget.appendChild(nav);
      }
    } else if (nav.nextElementSibling !== navHome) {
      closePanel(false);
      // Taking the nav out of an open drawer would leave an empty panel on screen,
      // so hand it back to theme.js's Drawer to close properly (scroll unlock, focus
      // restore) rather than just hiding it.
      if (drawer && drawer.classList.contains('drawer--visible')) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:close', { bubbles: false }));
      }
      navHome.parentNode.insertBefore(nav, navHome);
    }
  }

  function applyMode() {
    // Only relocate on an actual mode change. The observer below watches every class
    // change on the wrapper, and theme.js toggles js__header__stuck and
    // js__header__stuck__backdrop there on scroll.
    var changed = applyModeAttr();
    if (ready && changed) {
      applyRelocation();
    }
  }

  /* ----------------------------------------------------------------------
   * Panels
   * -------------------------------------------------------------------- */

  function triggerFor(panel) {
    return wrapper.querySelector('[data-nav-open="' + panel.id + '"]');
  }

  function setDepth(depth) {
    drawerTarget.setAttribute('data-nav-depth', String(depth));
  }

  function showPanel(panel) {
    if (!panel || openPanel === panel) {
      return;
    }
    openPanel = panel;
    panel.classList.add(classes.panelOpen);

    // The pane's own height is the level-0 list. Match the open panel instead so
    // .drawer__inner scrolls to the panel's real length.
    drawerTarget.style.setProperty('--nav-height', panel.scrollHeight + 'px');
    setDepth(1);

    var trigger = triggerFor(panel);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }

    var back = panel.querySelector(selectors.back);
    if (back) {
      back.focus();
    }
  }

  function closePanel(returnFocus) {
    if (!openPanel) {
      return;
    }
    var panel = openPanel;
    openPanel = null;

    setDepth(0);
    drawerTarget.style.removeProperty('--nav-height');
    panel.classList.remove(classes.panelOpen);

    var trigger = triggerFor(panel);
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus !== false) {
        trigger.focus();
      }
    }
  }

  /* ----------------------------------------------------------------------
   * Events
   * -------------------------------------------------------------------- */

  // Delegated, so it keeps working across relocation without rebinding.
  wrapper.addEventListener('click', function (event) {
    var drill = event.target.closest(selectors.drill);
    if (drill && drawerTarget.contains(drill)) {
      event.preventDefault();
      showPanel(document.getElementById(drill.getAttribute('data-nav-open')));
      return;
    }

    var back = event.target.closest(selectors.back);
    if (back && drawerTarget.contains(back)) {
      event.preventDefault();
      closePanel(true);
    }
  });

  // Escape ascends one level rather than dismissing the whole drawer.
  //
  // Must be CAPTURE phase. theme.js Drawer.closers() binds keyup on .header__drawer,
  // which is an ancestor of the nav but a descendant of the wrapper — so on the bubble
  // path the drawer's handler would run first and the drawer would already be closed
  // before this ran. Capturing at the wrapper puts us ahead of it, and stopPropagation
  // then cancels the remaining capture and the entire bubble phase.
  wrapper.addEventListener(
    'keyup',
    function (event) {
      if (event.code !== 'Escape' || !openPanel) {
        return;
      }
      event.stopPropagation();
      closePanel(true);
    },
    true
  );

  // HoverDisclosure's pointerenter still fires in the drawer (pointer events fire on
  // touch) and adds meganav--visible to the wrapper, which would drop the header out
  // of its transparent state. custom.css neutralises the panel styling; this undoes
  // the wrapper class. Capture phase so it runs before the class is read.
  wrapper.addEventListener(
    'pointerenter',
    function (event) {
      if (mode !== 'mobile' || !drawerTarget.contains(event.target)) {
        return;
      }
      requestAnimationFrame(function () {
        wrapper.classList.remove(classes.meganavVisible);
      });
    },
    true
  );

  // theme.js:2435 fires this when the drawer closes, for exactly this purpose.
  document.addEventListener('theme:sliderule:close', function () {
    closePanel(false);
  });

  // theme.js toggles js__show__mobile on the wrapper from its own width measurement.
  // Observing the class rather than measuring again guarantees relocation and the CSS
  // breakpoint can never disagree.
  new MutationObserver(applyMode).observe(wrapper, {
    attributes: true,
    attributeFilter: ['class']
  });

  if (narrow.addEventListener) {
    narrow.addEventListener('change', applyMode);
    coarse.addEventListener('change', applyMode);
  } else if (narrow.addListener) {
    narrow.addListener(applyMode);
    coarse.addListener(applyMode);
  }

  // Reflect the mode straight away so custom.css lays the row out correctly, then do
  // the actual move once theme.js has finished measuring. custom.js is deferred and
  // runs after theme.js, so this listener is registered after theme.js's and fires
  // after its load('*').
  applyModeAttr();

  function start() {
    ready = true;
    applyModeAttr();
    applyRelocation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();


(function () {
  'use strict';

  // Product description "read more".
  //
  // Pipeline built this state by duplicating the copy: theme.js's
  // ProductTemplate.truncateText() cloned .product-description__content, ran an
  // ellipsis routine over the clone to cut it to five rows, and left both copies in
  // the DOM for theme.css to swap display between. The description was output twice
  // on every product page, the second time cut mid-sentence.
  //
  // sections/product.liquid, sections/section-product.liquid and
  // snippets/product-tabs.liquid now render it once, under data-read-more-* hooks.
  // theme.js looks for data-truncated-content, finds none, and skips its truncation
  // altogether — so nothing here has to undo a clone, and no copy is ever made.
  //
  // The collapse itself is CSS (custom.css section 4). All this does is measure.

  var selectors = {
    holder: '[data-read-more]',
    content: '[data-read-more-content]',
    button: '[data-read-more-button]',
    accordionBody: '[data-accordion-body]',
    accordionTrigger: '[data-accordion-trigger]'
  };

  var classes = {
    measured: 'is-measured',
    clamped: 'is-clamped',
    open: 'is-open'
  };

  // Decide whether the description is longer than the clamp, which is the only
  // thing CSS cannot work out for itself.
  function measure(holder) {
    // Once opened it stays open. Resizing must not collapse it under the visitor.
    if (holder.classList.contains(classes.open)) {
      return;
    }

    var content = holder.querySelector(selectors.content);
    if (!content) {
      return;
    }

    // Dropping .is-measured puts the clamp back, so the comparison is always made
    // against the collapsed height even when we are re-measuring something that is
    // currently unclamped. Reading scrollHeight forces layout, so the measurement
    // sees the clamp; both writes land in the same task, so nothing paints between
    // them and there is no flicker.
    holder.classList.remove(classes.measured);
    var overflows = content.scrollHeight - content.clientHeight > 1;
    holder.classList.toggle(classes.clamped, overflows);
    holder.classList.add(classes.measured);
  }

  function measureAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll(selectors.holder), measure);
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    var button = event.target.closest(selectors.button);
    if (button) {
      var holder = button.closest(selectors.holder);
      if (holder) {
        event.preventDefault();
        holder.classList.add(classes.open);
        holder.classList.remove(classes.clamped);
        button.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    // In the accordion variant the description sits in an accordion__body that is
    // display:none until opened, so it measures as zero height and looks like it
    // fits. Re-measure once the body is on screen. theme.js's Accordion binds its
    // own click listener in the same phase but on the trigger itself, so it has
    // already run by the time this delegated listener fires; the frame wait is for
    // the slideDown that follows. No event of its own is dispatched to listen for.
    var trigger = event.target.closest(selectors.accordionTrigger);
    if (trigger) {
      var body = document.getElementById(trigger.getAttribute('data-accordion-trigger'));
      if (body && body.querySelector(selectors.holder)) {
        requestAnimationFrame(function () {
          measureAll(body);
        });
      }
    }
  });

  // theme.js dispatches this debounced on window resize.
  document.addEventListener('theme:resize', function () {
    measureAll();
  });

  // Theme editor re-renders a section's markup wholesale, losing the state classes.
  document.addEventListener('shopify:section:load', function (event) {
    measureAll(event.target);
  });

  function start() {
    measureAll();

    // A webfont swapping in changes the line count, and can land after this first
    // pass. Cheap enough to just measure again rather than guess.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        measureAll();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
